module.exports = __webpack_public_path__ + "static/img/pc-04.892a5e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w9/pc-04.jpg
// module id = Dl4w
// module chunks = 1